import { Controller } from 'react-hook-form';
import { Cell } from '@/shared/ui/Cell';
import { TextField as TextFieldComponent } from '@salutejs/sdds-insol';

type Props = {
    className?: string;
    disabled?: boolean;
    label: string;
    maxLength?: number;
    name: string;
    regExpToTest?: RegExp;
    size?: 'l' | 'm' | 's' | 'xl' | 'xs';
    onChange?: (value: string) => void;
};

export const TextField = ({
    className,
    name,
    size = 'xl',
    regExpToTest,
    label,
    disabled = false,
    maxLength,
    onChange,
}: Props) => {
    return (
        <Controller
            render={({ field, fieldState }) => {
                const onInputChange = (value: string) => {
                    field.onChange(value);
                    onChange?.(value);
                };

                return (
                    <Cell className={className} error={fieldState.error?.message}>
                        <TextFieldComponent
                            name={name}
                            size={size}
                            label={label}
                            readOnly={disabled}
                            value={field.value}
                            maxLength={maxLength}
                            labelPlacement="inner"
                            onChange={(e) => {
                                const { value } = e.target;

                                if (!regExpToTest) {
                                    onInputChange(value);
                                }

                                const isPassed = regExpToTest?.test(value);

                                if (isPassed || value === '') {
                                    onInputChange(value);
                                } else {
                                    e.stopPropagation();
                                }
                            }}
                        />
                    </Cell>
                );
            }}
            name={name}
        />
    );
};
